import { differenceInDays } from 'date-fns';
import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { LocalStorage } from '@services/local-storage';
import { PlatformFeatureFlagService } from '@services/feature-flags/platform';
import { browserNotSupported } from '@lib/check-browser-version';

@Component({
  selector: 'unsupported-browser-banner',
  templateUrl: './unsupported-browser-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class UnsupportedBrowserBannerComponent {
  @Output() public onBannerClose = new EventEmitter();
  @Output() public onBannerOpen = new EventEmitter();
  private notSupported: boolean;
  private daysPassed: number;

  constructor(
    private localStorage: LocalStorage,
    public platformFeatureFlagService: PlatformFeatureFlagService,
  ) { }

  public ngOnInit(){
    this.notSupported = false;
    this.daysPassed = 0;

    if (this.platformFeatureFlagService.isMinimumBrowserCheckEnabled()) {
      this.notSupported = browserNotSupported;
      const storedDate = new Date(this.localStorage.getBannerCloseDate());
      const currentDate = new Date();
      this.daysPassed = differenceInDays(currentDate, storedDate);
    }
  }

  public get validBrowser(){
    return (this.daysPassed >= 7 && this.notSupported);
  }

  public updateBannerClosingDate(): void {
    const currentDate = new Date().toISOString();
    this.localStorage.setBannerCloseDate(currentDate);
  }
}
